<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showDeliveryDetailSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div class="sidebar-header-title">Edit Delivery Details</div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 176px)'}"
                       [styleClass]="'app-scrollpanel'">

            <div class="store-delivery-title">
                Location Details
            </div>

            <div class="sd-field-block">
                <div class="sd-field-block__label">Street Address</div>
                <p-autoComplete [(ngModel)]="storeData.PickupAddress"
                                [suggestions]="addresses"
                                (completeMethod)="search($event)"
                                placeholder="Search Google Maps"
                                (click)="geocodeClick()"
                                [inputStyle]="{'width': '656px', 'padding': '10px 15px'}">
                </p-autoComplete>
            </div>

            <div class="sd-field-block">
                <div class="sd-field-block__label">Location Details</div>
                <div class="flex flex-row">
                    <div class="sd-field-column">
                        <input type="text" [(ngModel)]="storeData.PickupTitle" pInputText />
                    </div>
                    <div class="sd-field-column">
                        <p-dropdown placeholder="Location Type" [(ngModel)]="storeData.LocationTypeId" [options]="locationType"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
            </div>

            <div class="sd-field-block">
                <input type="text" [(ngModel)]="storeData.PickupAddressDetail" placeholder="Street Address" pInputText />
            </div>

            <div class="sd-field-block">
                <div class="sd-field-block__label">Store External Photos:</div>
                <div class="flex flex-row">
                    <div class="store-upload-img-block" *ngIf="storeData.PickupImageUrl">
                        <img src="{{storeData.PickupImageUrl}}" class="store-upload-img" />
                    </div>

                    <div class="store-upload-img-block">
                        <input id="idImgInput"
                               type="file"
                               accept="image/*"
                               style="display: none"
                               (change)="handleImageChange($event)" required />
                        <div class="store-upload-img__add-link" (click)="handleImageClick('idImgInput')">
                            <img src="/XpressApp/assets/images/store/add-plus-circle.svg" />
                            <div class="store-upload-img__add-title">
                                Add
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </p-scrollPanel>

        <div class="flex justify-content-end mrg-10-0px" *ngIf="!loading">
            <button class="bluedark-btn" pButton label="Save Changes" (click)="updateDeliveryDetail()"></button>
        </div>
    </div>
</p-sidebar>